const BaseUrl = {
  API_URL: "https://api.armesecrete.com/",
};

export default BaseUrl;
